import { CompanyClassificationType } from '../../constants-types';
import { PISignalRMessage, PISignalRMessageData } from '../../core-services';

export class DemoAccountSignalRNotificationData
    implements PISignalRMessageData
{
    CompanyGuid: string;
    CompanyName: string;
    CompanyClassificationType: CompanyClassificationType =
        CompanyClassificationType.Unknown;
    Status: DemoAccountSignalrNotificationStatus;
}

export class DemoAccountSignalRNotificationDataMessage
    implements PISignalRMessage<DemoAccountSignalRNotificationData>
{
    data = new DemoAccountSignalRNotificationData();
    eventTarget = 'DemoAccountSignalRNotification';
}

export type DemoAccountSignalrNotificationStatus =
    | 'Unknown'
    | 'CreatingCompany'
    | 'AddingUsers'
    | 'AddingThirdPartyUsers'
    | 'CreatingUsers'
    | 'CreatingSurveyUsers'
    | 'CreatingTeams'
    | 'CreatingJobs'
    | 'AddedUsers'
    | 'AddedThirdPartyUsers'
    | 'Completed'
    | 'Failed'
    | 'UpdateFailed';
